/** Нижняя навигация. Четыре таба.
 *
 *  Здесь стояло «ровно три — четвёртый пришлось бы придумывать», и это было
 *  честно: раздел ради симметрии хуже пустого места. Четвёртый не придуман —
 *  «Спросить» отвечает на вопросы по записям, и прятать его строкой на главной
 *  значит прятать половину смысла: до него надо долистать.
 *
 * Активный получает ПОДЛОЖКУ, а не только синий цвет: цвет как единственный
 * носитель смысла — нарушение WCAG 1.4.1, и наш собственный бренд-бук это
 * запрещает. Синий и серый отличаются в 1.85 раза — этого мало.
 */
import { tap } from "../lib/telegram.ts";

export type Tab = "home" | "ops" | "capital" | "ask";

const PATHS: Record<Tab, string[]> = {
  home: ["M3.5 10.4L12 4l8.5 6.4V19a1.6 1.6 0 01-1.6 1.6H5.1A1.6 1.6 0 013.5 19z", "M9.5 20.6v-6h5v6"],
  ops: ["M4 6.5h16M4 12h16M4 17.5h10"],
  capital: ["M4 19V9M10 19V5M16 19v-7M21 19H3"],
  // Звезда-искра и подпись «AI» — то же, что в соседнем мини-аппе про питание.
  // Два приложения живут на одном телефоне, и называть одно и то же разными
  // словами значит заставлять человека переучиваться при переходе.
  ask: ["M12 3l1.9 4.8L19 9.7l-4.2 3 .7 5.3-3.5-2.6L8.5 18l.7-5.3-4.2-3 5.1-1.9z"],
};
// Порядок объявления = порядок на экране. AI последний, как у соседа: он не
// про ежедневную работу с записями, а про разговор поверх них.
const LABELS: Record<Tab, string> = {
  home: "Главная", ops: "Операции", capital: "Капитал", ask: "AI",
};

/** Высота панели вместе с безопасной зоной — под неё резервируется место,
 *  иначе последняя строка списка окажется под ней. */
export const TAB_BAR_HEIGHT = "calc(69px + var(--tg-safe-bottom, 0px))";

export function TabBar({ active, onChange }: { active: Tab; onChange: (t: Tab) => void }) {
  return (
    <nav style={{
      display: "flex",
      padding: "8px 6px calc(12px + var(--tg-safe-bottom, 0px))",
      borderTop: "1px solid var(--separator)",
      background: "var(--bg)",
      // Fixed, а не sticky: sticky зависит от того, какой предок скроллится, и в
      // Telegram WebView это оказался не тот элемент, на который я рассчитывал.
      // Место под панель держит отступ у main.
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 5,
    }}>
      {(Object.keys(LABELS) as Tab[]).map((tab) => {
        const on = tab === active;
        return (
          <button key={tab} type="button" aria-current={on ? "page" : undefined}
            onClick={() => { tap(); onChange(tab); }}
            style={{ flexGrow: 1, minHeight: "var(--tap)", background: "none", border: "none",
                     padding: "2px 0", cursor: "pointer", font: "inherit",
                     color: on ? "var(--accent)" : "var(--text-faint)" }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center",
                           width: 56, height: 32, borderRadius: "var(--r-pill)",
                           background: on ? "var(--accent-tint)" : "transparent" }}>
              <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                {PATHS[tab].map((d) => <path key={d} d={d} />)}
              </svg>
            </span>
            <span style={{ display: "block", fontSize: "var(--f-micro)", marginTop: 3,
                           fontWeight: on ? 600 : 500, letterSpacing: ".2px" }}>
              {LABELS[tab]}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
